import { createSlice } from '@reduxjs/toolkit';

import { getReports } from './api';

export const ReportPlatformSlice = createSlice({
    name: 'ReportPlatformSlice',
    initialState: {
        isLoading: false,
        reportsData : [],
        error: ''
    },

    reducers: {
      clear: (state, action) => {
        return {
          ...state,
          [action.payload.key]: action.payload.value
        }
      }
    },

    extraReducers: (builder) => {
        builder.addCase(getReports.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getReports.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.reportsData = action.payload.data;
        })
        builder.addCase(getReports.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clear } = ReportPlatformSlice.actions


export default ReportPlatformSlice.reducer